"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _getUrlFromProps = require("../../resources/functions/getUrlFromProps");

var _ModelsTable = _interopRequireDefault(require("./ModelsTable"));

var _ModelsList = _interopRequireDefault(require("./ModelsList"));

var _ModelsGrid = _interopRequireDefault(require("./ModelsGrid"));

var _ModelsGallery = _interopRequireDefault(require("./ModelsGallery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class LayoutModels extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      models: [],
      modelsById: {},
      layout: undefined,
      groups: undefined,
      sortBy: undefined,
      sortOrder: undefined
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.layout !== this.props.layout) {
        this.getLayout();
      }

      if (prevProps.models !== this.props.models) {
        this.getModels();
      }

      if (prevState.sortBy !== this.state.sortBy) {
        this.sortModels();
      }
    });

    _defineProperty(this, "getLayout", () => {
      const layout = this.props.layout;
      this.setState({
        layout: layout
      });
    });

    _defineProperty(this, "getMetadata", model => {
      let metadata = model.metadata,
          size = model.size,
          mediaWidth = model.mediaWidth,
          mediaHeight = model.mediaHeight,
          mediaSize = model.mediaSize;

      if (metadata) {
        return metadata;
      }

      metadata = [];
      size = size || mediaWidth && mediaHeight && mediaWidth + "×" + mediaHeight || undefined;

      if (size) {
        metadata.push(size);
      }

      return metadata.join(' – ');
    });

    _defineProperty(this, "getByline", model => {
      const deletedAt = model.deletedAt,
            deletedByName = model.deletedByName,
            updatedAt = model.updatedAt,
            updatedByName = model.updatedByName,
            createdAt = model.createdAt,
            createdByName = model.createdByName;
      let author = model.author,
          datetime = model.datetime;

      if (!datetime && deletedAt) {
        datetime = deletedAt;
      } else if (!datetime && updatedAt) {
        datetime = updatedAt;
      } else if (!datetime && createdAt) {
        datetime = createdAt;
      }

      if (author) {
        author = author;
      } else if (deletedAt && deletedByName) {
        author = deletedByName;
        datetime = deletedAt;
      } else if (updatedAt && updatedByName) {
        author = updatedByName;
        datetime = updatedAt;
      } else if (createdAt && createdByName) {
        author = createdByName;
        datetime = createdAt;
      }

      return {
        author: author || "N/A",
        datetime: datetime
      };
    });

    _defineProperty(this, "getLabel", model => {
      let label = model.label,
          documentType = model.documentType,
          mediaType = model.mediaType,
          mimeType = model.mimeType;
      return label || mediaType || documentType || undefined;
    });

    _defineProperty(this, "getSortSize", model => {
      let size = model.size,
          sortSize = model.sortSize,
          mediaWidth = model.mediaWidth,
          mediaSize = model.mediaSize;
      return sortSize || mediaSize || mediaWidth && mediaWidth && mediaWidth * mediaWidth || undefined;
    });

    _defineProperty(this, "onEdit", model => {
      console.log('LayoutModels:onEdit', model);

      if (model.onEdit) {
        model.onEdit(model);
      } else if (this.props.onEdit) {
        this.props.onEdit(model);
      }
    });

    _defineProperty(this, "onView", model => {
      console.log('LayoutModels:onView', model);

      if (model.onView) {
        model.onView(model);
      } else if (this.props.onView) {
        this.props.onView(model);
      }
    });

    _defineProperty(this, "onRefs", model => {
      console.log('LayoutModels:onRefs', model);

      if (model.onRefs) {
        model.onRefs(model);
      } else if (this.props.onRefs) {
        this.props.onRefs(model);
      }
    });

    _defineProperty(this, "onDelete", model => {
      console.log('LayoutModels:onDelete', model);

      if (model.onDelete) {
        model.onDelete(model);
      } else if (this.props.onDelete) {
        this.props.onDelete(model);
      }
    });

    _defineProperty(this, "onRestore", model => {
      console.log('LayoutModels:onRestore', model);

      if (model.onRestore) {
        model.onRestore(model);
      } else if (this.props.onRestore) {
        this.props.onRestore(model);
      }
    });

    _defineProperty(this, "onErase", model => {
      console.log('LayoutModels:onErase', model);

      if (model.onErase) {
        model.onErase(model);
      } else if (this.props.onErase) {
        this.props.onErase(model);
      }
    });

    _defineProperty(this, "onToggle", model => {
      console.log('LayoutModels:onToggle', model);

      if (model.onToggle) {
        model.onToggle(model);
      } else if (this.props.onToggle) {
        this.props.onToggle(model);
      }
    });

    _defineProperty(this, "onAdd", model => {
      console.log('LayoutModels:onAdd', model);

      if (model.onAdd) {
        model.onAdd(model);
      } else if (this.props.onToggle) {
        this.props.onAdd(model);
      }
    });

    _defineProperty(this, "onRemove", model => {
      console.log('LayoutModels:onRemove', model);

      if (model.onRemove) {
        model.onRemove(model);
      } else if (this.props.onRemove) {
        this.props.onRemove(model);
      }
    });

    _defineProperty(this, "onSelect", model => {
      console.log('LayoutModels:onSelect', model);

      if (model.onSelect) {
        model.onSelect(model);
      } else if (this.props.onSelect) {
        this.props.onSelect(model);
      }
    });

    _defineProperty(this, "onUnselect", model => {
      console.log('LayoutModels:onUnselect', model);

      if (model.onUnselect) {
        model.onUnselect(model);
      } else if (this.props.onUnselect) {
        this.props.onUnselect(model);
      }
    });

    _defineProperty(this, "getToolbar", model => {
      const status = model.status,
            selected = model.selected;
      const moduleAction = model.moduleAction || this.props.moduleAction;
      let toolbar = []; // edit, view, refs

      if (moduleAction.includes('edit')) {
        toolbar.push({
          name: "edit",
          onClick: () => this.onEdit(model)
        });
      }

      if (moduleAction.includes('view')) {
        toolbar.push({
          name: "view",
          onClick: () => this.onView(model)
        });
      }

      if (moduleAction.includes('refs')) {
        toolbar.push({
          name: "refs",
          onClick: () => this.onRefs(model)
        });
      } // delete + restore


      if (moduleAction.includes('delete') && status === "trash" || moduleAction.includes("restore")) {
        toolbar.push({
          name: "restore",
          onClick: () => this.onRestore(model)
        });
      } else if (moduleAction.includes("delete")) {
        toolbar.push({
          name: "delete",
          onClick: () => this.onDelete(model)
        });
      } // erase


      if (moduleAction.includes('erase') && status === "trash") {
        toolbar.push({
          name: "erase",
          onClick: () => this.onErase(model)
        });
      } // select + unselect

      /*
       if (moduleAction.includes('select') && selected || moduleAction.includes("unselect")) {
          toolbar.push({
              name: "unselect",
              onClick: () => this.onUnselect(model)
          })
      } else if (moduleAction.includes("select")) {
          toolbar.push({
              name: "unselect",
              onClick: () => this.onSelect(model)
          })
      }        
       */
      // add + remove


      if (moduleAction.includes('add') && selected || moduleAction.includes("remove")) {
        toolbar.push({
          name: "remove",
          onClick: () => this.onRemove(model)
        });
      } else if (moduleAction.includes("add")) {
        toolbar.push({
          name: "add",
          onClick: () => this.onAdd(model)
        });
      } // toggle

      /*
       if (moduleAction.includes('toggle') && selected) {
          toolbar.push({
              name: "selected",
              onClick: () => this.onToggle(model)
          })
      } else if (moduleAction.includes('toggle')) {
          toolbar.push({
              name: "select",
              onClick: () => this.onToggle(model)
          })
      }
       */


      return toolbar;
    });

    _defineProperty(this, "getModel", model => {
      const _this$props = this.props,
            urlPattern = _this$props.urlPattern,
            editUrlPattern = _this$props.editUrlPattern,
            refsUrlPattern = _this$props.refsUrlPattern;
      const url = model.url,
            editUrl = model.editUrl,
            refsUrl = model.refsUrl;
      const moduleFooter = model.moduleFooter || this.props.moduleFooter;
      const moduleAction = model.moduleAction || this.props.moduleAction;

      const _this$getByline = this.getByline(model),
            author = _this$getByline.author,
            datetime = _this$getByline.datetime;

      let selectable, onSelect;

      if (moduleAction && moduleAction.includes('select')) {
        onSelect = () => this.onSelect(model);

        selectable = true;
      }

      let onClick;

      if (selectable && moduleAction.length === 1) {
        onClick = onSelect;
      }

      return _extends({}, model, {
        selectable: selectable,
        onSelect: onSelect,
        label: this.getLabel(model),
        description: this.getMetadata(model),
        author: author,
        datetime: datetime,
        sortSize: this.getSortSize(model),
        toolbar: this.getToolbar(model),
        url: url || (0, _getUrlFromProps.getUrlFromProps)(model, urlPattern) || undefined,
        editUrl: editUrl || (0, _getUrlFromProps.getUrlFromProps)(model, editUrlPattern) || undefined,
        refsUrl: refsUrl || (0, _getUrlFromProps.getUrlFromProps)(model, refsUrlPattern) || undefined,
        moduleFooter: moduleFooter,
        moduleAction: moduleAction,
        onClick: onClick,
        onEdit: () => this.onEdit(model)
        /*
        onEdit: () => this.onEdit(model),
        onDelete: () => this.onDelete(model),
        onRestore: () => this.onRestore(model),
        onToggle: () => this.onToggle(model),
        onSelect: () => this.onSelect(model),
        onUnselect: () => this.onUnselect(model),
        onAdd: () => this.onAdd(model),
        onRemove: () => this.onRemove(model),
        */

      });
    });

    _defineProperty(this, "getModels", () => {
      const _this$props2 = this.props,
            models = _this$props2.models,
            sortBy = _this$props2.sortBy,
            sortOrder = _this$props2.sortOrder,
            groupBy = _this$props2.groupBy;
      let modelsById = {};
      models.map((model, index) => {
        const uniqueId = model.uniqueId,
              source = model.source,
              sourceId = model.sourceId;
        const id = uniqueId || source && sourceId && source + "/" + sourceId || index || undefined;
        modelsById[id] = this.getModel(model);
      });
      this.setState({
        modelsById: modelsById,
        models: Object.values(modelsById),
        sortBy: sortBy,
        sortOrder: sortOrder,
        groupBy: groupBy
      });
    });

    _defineProperty(this, "sortModels", () => {
      let _this$state = this.state,
          models = _this$state.models,
          sortBy = _this$state.sortBy,
          sortOrder = _this$state.sortOrder,
          groupBy = _this$state.groupBy,
          groups = _this$state.groups;

      if (sortBy && sortOrder) {
        models = _lodash.default.orderBy(models, sortBy, sortOrder); // Use Lodash to sort array by 'name'
      }

      if (groupBy) {
        groups = _lodash.default.groupBy(models, groupBy); // Use Lodash to sort array by 'name'
      }

      this.setState({
        models: models,
        groups: groups
      });
    });

    _defineProperty(this, "onSort", (sortBy, sortOrder) => {
      if (this.props.onSort) {
        this.props.onSort(sortBy, sortOrder);
      }

      let models = this.state.models;
      models = _lodash.default.orderBy(models, sortBy, sortOrder); // Use Lodash to sort array by 'name'

      this.setState({
        sortBy: sortBy,
        sortOrder: sortOrder,
        models: models
      });
    });
  }

  componentDidMount() {
    this.getModels();
    this.getLayout();
  }

  render() {
    const _this$props3 = this.props,
          padding = _this$props3.padding,
          spacing = _this$props3.spacing;
    const _this$state2 = this.state,
          layout = _this$state2.layout,
          models = _this$state2.models,
          groups = _this$state2.groups,
          sortBy = _this$state2.sortBy,
          sortOrder = _this$state2.sortOrder;
    const layouts = {
      "table": _ModelsTable.default,
      "list": _ModelsList.default,
      "grid": _ModelsGrid.default,
      "gallery": _ModelsGallery.default
    };
    let ModelsTemplate;

    if (layout && layouts[layout]) {
      ModelsTemplate = layouts[layout];
    } else {
      ModelsTemplate = layouts['table'];
    }

    return _react.default.createElement(ModelsTemplate, {
      models: models,
      padding: padding,
      spacing: spacing,
      groups: groups,
      onSort: this.onSort,
      sortBy: sortBy,
      sortOrder: sortOrder
    });
  }

}

_defineProperty(LayoutModels, "defaultProps", {
  models: [],
  groups: undefined,
  sortBy: undefined,
  sortOrder: 'ascending',
  groupBy: undefined,
  groupOrder: undefined
});

LayoutModels.propTypes = process.env.NODE_ENV !== "production" ? {
  models: _propTypes.default.arrayOf(_propTypes.default.shape({
    documentType: _propTypes.default.string,
    mediaType: _propTypes.default.string,
    imageUrl: _propTypes.default.string,
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    label: _propTypes.default.string,
    metadata: _propTypes.default.array,
    createdAt: _propTypes.default.string,
    updatedAt: _propTypes.default.string
  })).isRequired,
  layout: _propTypes.default.string,
  padding: _propTypes.default.number,
  spacing: _propTypes.default.number,
  groups: _propTypes.default.object,
  sortBy: _propTypes.default.string,
  sortOrder: _propTypes.default.string,
  groupBy: _propTypes.default.string,
  groupOrder: _propTypes.default.string,
  moduleFooter: _propTypes.default.bool,
  moduleAction: _propTypes.default.array,
  urlPattern: _propTypes.default.string,
  editUrlPattern: _propTypes.default.string,
  refsUrlPattern: _propTypes.default.string
} : {};
var _default = LayoutModels;
exports.default = _default;
module.exports = exports.default;